import type { FavouritesApiClient } from '@/scopes/favourites/domain/favouriteTypes'
import { createFavouritesApiClient } from './favouritesApiClient'

export const favouritesAPIClient: FavouritesApiClient = createFavouritesApiClient()
